module.exports = {"530922101":"爱华镇","530922102":"漫湾镇","530922103":"大朝山西镇","530922104":"涌宝镇","530922105":"茂兰镇","530922106":"幸福镇","530922107":"大寨镇","530922201":"忙怀彝族布朗族乡","530922202":"晓街乡","530922203":"茶房乡","530922204":"栗树彝族傣族乡","530922205":"后箐彝族乡","530922501":"幸福农场","530922502":"新城农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530922.json
// module id = 2608
// module chunks = 0